import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { LANGUAGES } from './languages';
import { useLang, useT } from './LanguageContext';

export default function LanguageSwitch({ sx }) {
  const { lang, setLang } = useLang();
  const t = useT();
  return (
    <ToggleButtonGroup size="small" exclusive value={lang} aria-label={t('common.language')}
      onChange={(_, v) => v && setLang(v)}
      sx={{ '& .MuiToggleButton-root': { py: 0.2, px: 1, fontSize: '0.72rem', lineHeight: 1.4 }, ...sx }}>
      {LANGUAGES.map((l) => (
        <ToggleButton key={l.code} value={l.code} aria-label={l.name}>{l.code.toUpperCase()}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
